import "./instrument";
import React from "react";
import ReactDOM from "react-dom/client";
import * as Sentry from "@sentry/react";
import { LazyMotion } from "framer-motion";
import "@/index.css";
import App from "@/App";
// v17.10.avatar-fallback — global listener swap broken avatar → DiceBear.
import "@/lib/avatarFallback";
// Phase 0 housekeeping "apex-edge-declined" (02-2026) — RUM HTML TTFB.
// Chỉ install collector; module tự defer sau window.load, 10% sample.
// ADR: /app/memory/adr-apex-edge-declined.md
import { installRumHtmlTtfb } from "@/lib/rumHtmlTtfb";
installRumHtmlTtfb();

// v17.15.1 — Xoá query `_r=<ts>` (cache-bust ChunkLoadError recovery) khỏi
// URL TRƯỚC khi React mount + trước analytics/visitor tracker → không sinh
// pageview trùng, giữ URL sạch cho canonical/share. Chạy đồng bộ, best-effort.
try {
  if (typeof window !== "undefined" && window.location.search.includes("_r=")) {
    const _url = new URL(window.location.href);
    if (_url.searchParams.has("_r")) {
      _url.searchParams.delete("_r");
      window.history.replaceState({}, "", _url.toString());
    }
  }
} catch { /* noop */ }

// v17.11 Lazy Load Đợt 2 — Framer-motion `LazyMotion` với ASYNC feature
// load. Trước: `motion.div` kéo full ~30KB gzip framer-motion vào initial
// bundle. Sau: LazyMotion + `m as motion` alias → domMax features (~24KB)
// tải dạng chunk RIÊNG bên ngoài main bundle. Initial paint mobile giảm
// đáng kể vì browser không phải parse framer-motion trước first render.
const loadFramerFeatures = () =>
  import(/* webpackChunkName: "framer-motion-dommax" */ "framer-motion").then(
    (mod) => mod.domMax,
  );

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary
      fallback={
        <div
          data-testid="app-error-fallback"
          style={{ padding: 40, textAlign: "center", fontFamily: "sans-serif" }}
        >
          <h2>Đã có lỗi xảy ra</h2>
          <p>Vui lòng tải lại trang. Lỗi đã được ghi nhận tự động.</p>
        </div>
      }
    >
      <LazyMotion features={loadFramerFeatures}>
        <App />
      </LazyMotion>
    </Sentry.ErrorBoundary>
  </React.StrictMode>,
);
